export default "__VITE_ASSET__BwcRtfC3__"